"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditScoreRow = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const base_react_components_1 = require("@navinc/base-react-components");
const report_summary_item_1 = require("../report-summary-item");
const has_score_1 = __importDefault(require("../../utils/has-score"));
const credit_score_box_1 = __importDefault(require("./credit-score-box"));
const loading_dots_1 = __importDefault(require("../loading-dots"));
const scoring_model_1 = require("../../utils/scoring-model");
const ScoreContainer = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreContainer", componentId: "reports-1jho8rn" }) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0;

  & > ${base_react_components_1.NextButton} {
    margin-top: 16px;
  }
`;
const CreditScoreRow = ({ bureau, hasMatch = false, isActive = false, isLoading = false, link, score, isPartnerCreditSuite = false, reportType, }) => {
    const scoringModel = (0, scoring_model_1.getScoringModel)(bureau, reportType);
    const bureauNameWithType = scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.displayNameWithType;
    const renderBusinessErrors = () => {
        if (!hasMatch) {
            return (react_1.default.createElement(base_react_components_1.CardInsight, { actionHref: `/partner/business-match/${bureau}`, actionLabel: "Find my business", copy: "We didn't find your business. Let's try again.", type: "improve", "data-testid": "card-insight:we-did-not-find-business" }));
        }
        if ((0, has_score_1.default)(score) || isLoading)
            return;
        return (react_1.default.createElement(base_react_components_1.CardInsight, { copy: `${(bureauNameWithType !== null && bureauNameWithType !== void 0 ? bureauNameWithType : 'Bureau').replace(/[®]+/g, '')}  doesn’t have enough business credit data to generate a business credit score.`, actionHref: (!isPartnerCreditSuite && '/partner/education/tradeline') || undefined, actionLabel: (!isPartnerCreditSuite && 'Establish business credit') || undefined, type: "improve" }));
    };
    return (react_1.default.createElement("div", { "data-testid": `credit-reports:credit-scores:${bureau}-score-row` },
        react_1.default.createElement(base_react_components_1.Divider, null),
        react_1.default.createElement(ScoreContainer, { to: link, as: (0, has_score_1.default)(score) && link ? react_router_dom_1.Link : 'div', "data-testid": `home:score_card_container_link_${bureau}` },
            bureauNameWithType && (react_1.default.createElement(report_summary_item_1.ReportSummaryItem, { status: isActive ? 'poor' : undefined, title: bureauNameWithType, "data-testid": `credit-reports:credit-scores:${bureau}-name` }, scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.reportableType)),
            isLoading ? (react_1.default.createElement(loading_dots_1.default, null)) : (hasMatch &&
                (0, has_score_1.default)(score) && react_1.default.createElement(credit_score_box_1.default, { bureau: bureau, hasLink: true, score: score, reportableType: reportType }))),
        renderBusinessErrors()));
};
exports.CreditScoreRow = CreditScoreRow;
exports.default = (0, styled_components_1.default)(exports.CreditScoreRow).withConfig({ componentId: "reports-bakfw6" }) ``;
//# sourceMappingURL=credit-score-row.js.map